var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Pipe } from '@angular/core';
import { TimeUnit } from './../util/index';
import { DatePipe } from '@angular/common';
/**
 * usage:
 *  {{123000 | timeElapsed}}
 *  {{123 | timeElapsed : TimeUnit.SECONDS}}
 */
export let TimeElapsedPipe = class TimeElapsedPipe {
    constructor() {
        this.datePipe = new DatePipe("en-US");
    }
    transform(duration, timeUnit = TimeUnit.MILLISECONDS) {
        let date = new Date(1970, 0, 1).setMilliseconds(timeUnit.toMillis(duration));
        return this.datePipe.transform(date, "HH:mm:ss");
    }
};
TimeElapsedPipe = __decorate([
    Pipe({
        name: 'timeElapsed',
    }), 
    __metadata('design:paramtypes', [])
], TimeElapsedPipe);
//# sourceMappingURL=time-elapsed.pipe.js.map